<template>
  <div v-if="localShowEditMetadata" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-xl max-w-lg w-full p-6">
      <h3 class="text-lg font-semibold mb-4">Editar Información</h3>
      
      <div class="space-y-4">
        <div>
          <label class="block text-gray-700 text-sm font-bold mb-2" for="editClientName">
            Nombre del Cliente
          </label>
          <input
            id="editClientName"
            v-model="localEditForm.clientName"
            type="text"
            class="w-full p-3 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-300 focus:border-blue-500 outline-none"
          />
        </div>

        <div>
          <label class="block text-gray-700 text-sm font-bold mb-2" for="editEquipment">
            Equipo
          </label>
          <input
            id="editEquipment"
            v-model="localEditForm.equipment"
            type="text"
            class="w-full p-3 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-300 focus:border-blue-500 outline-none"
          />
        </div>

        <div>
          <label class="block text-gray-700 text-sm font-bold mb-2" for="editPeriod">
            Período
          </label>
          <select
            id="editPeriod"
            v-model="localEditForm.period"
            class="w-full p-3 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-300 focus:border-blue-500 outline-none"
          >
            <option value="Anual">Anual</option>
            <option value="Mensual">Mensual</option>
            <option value="Trimestral">Trimestral</option>
          </select>
        </div>

        <div>
          <label class="block text-gray-700 text-sm font-bold mb-2" for="editSecondTechnician">
            Segundo Técnico
          </label>
          <select
            id="editSecondTechnician"
            v-model="localEditForm.secondTechnicianId"
            class="w-full p-3 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-300 focus:border-blue-500 outline-none"
          >
            <option value="no_aplica">No Aplica</option>
            <option 
              v-for="tech in availableTechnicians" 
              :key="tech.id" 
              :value="tech.id"
            >
              {{ tech.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="mt-6 flex justify-end gap-3">
        <button
          @click="closeModal"
          class="px-4 py-2 text-gray-600 hover:text-gray-800"
        >
          Cancelar
        </button>
        <button
          @click="saveChanges"
          class="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          Guardar Cambios
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showEditMetadata: Boolean,
    editForm: Object,
    availableTechnicians: Array,
  },
  data() {
    return {
      localShowEditMetadata: this.showEditMetadata,
      localEditForm: { ...this.editForm }
    };
  },
  watch: {
    showEditMetadata(newVal) {
      this.localShowEditMetadata = newVal;
    },
    editForm(newVal) {
      this.localEditForm = { ...newVal };
    }
  },
  methods: {
    closeModal() {
      this.localShowEditMetadata = false;
      this.$emit('update:showEditMetadata', false);
    },
    saveChanges() {
      this.$emit('save-metadata-changes', this.localEditForm);
      this.closeModal();
    }
  }
};
</script>
